"use client";

import { ReactNode } from 'react';

interface LayoutProps {
  onClose: () => void;
  isSidebarOpen: boolean; 
  children: ReactNode;
}

export default function LayoutCenter({ children, onClose }: LayoutProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70">
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-6xl mx-4"
        style={{
          maxHeight: '95vh',
          overflowY: 'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
}
